// frontend/src/hooks/useClaimEligibility.js
import { useQuery } from '@tanstack/react-query';
import { staffAPI } from '../services/api';

/**
 * Handbook Clause 8 medical claim eligibility (reimbursed via Petty Cash).
 * Petty Cash app should also call this (or read JWT is_confirmed_staff).
 */
export const useClaimEligibility = (options = {}) => {
  const { category, enabled = true } = options;

  return useQuery({
    queryKey: ['claims', 'eligibility', category || 'all'],
    queryFn: async () => {
      const response = await staffAPI.getClaimEligibility(
        category ? { category } : {},
      );
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
};

export default useClaimEligibility;
